<template>
  <v-container>
    <v-layout row wrap slot="placeholder" align-center justify-center ma-0>
        <div>
          <v-img src="/static/img/work.png" aspect-ratio="2.3" contain></v-img>
          <br>
          <h1>We are currently working on something awesome. Stay tuned!</h1>
          <br>
        </div>
      <v-flex xs12 sm 4 text-xs-center>
          <v-btn color="primary" :to="{ name: 'dashboard' }">Go to Dashboard</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {
  }
}
</script>

<style lang="scss">
</style>
